import { Keyword, LengthPercentage, Number, Token, Tuple, } from "@siteimprove/alfa-css";
import { Parser } from "@siteimprove/alfa-parser";
import { Selective } from "@siteimprove/alfa-selective";
import { Longhand } from "../longhand.js";
import { Resolver } from "../resolver.js";
const { takeBetween, either, map, filter, delimited, option } = Parser;
/**
 * @internal
 */
export const parse = map(takeBetween(delimited(option(Token.parseWhitespace), either(filter(either(LengthPercentage.parse, Number.parse), (size) => size.hasCalculation() || size.value >= 0, () => `Negative sizes are not allowed`), Keyword.parse("auto"))), 1, 4), ([top, right = top, bottom = top, left = right]) => Tuple.of(top, right, bottom, left));
/**
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/border-image-width}
 * @internal
 */
export default Longhand.of(Tuple.of(Number.of(1), Number.of(1), Number.of(1), Number.of(1)), parse, (value, style) => value.map(({ values: [t, r, b, l] }) => {
    const resolver = resolve(style);
    return Tuple.of(resolver(t), resolver(r), resolver(b), resolver(l));
}));
function resolve(style) {
    return (specified) => Selective.of(specified)
        .if(LengthPercentage.isLengthPercentage, LengthPercentage.partiallyResolve(Resolver.length(style)))
        .if(Number.isNumber, (num) => num.resolve())
        .get();
}
//# sourceMappingURL=border-image-width.js.map